// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"a9a7754c","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"112":"e11240872494181e83a2","532":"83ddec6ecc0871432b8e","678":"266db5324d4d171c24d7","883":"ac7529be7e55f367519d"}[chunkId] + ".js";
};